
import { defineComponent } from 'vue'
import PortalMixin from '@/mixins/portalMixin'

export default defineComponent({
  mixins: [PortalMixin],
  name: 'DefaultLayout',
  components: {},
  head: {
    bodyAttrs: {
      class: 'antialiased stroke-2 hide-scroll'
    }
  }
})
